import * as React from 'react';
import icon from '../../assets/img/flags/ohio.svg';

export const Ohio = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
